import { render } from "./praise.vue?vue&type=template&id=601e0ac5&scoped=true"
import script from "./praise.vue?vue&type=script&lang=js"
export * from "./praise.vue?vue&type=script&lang=js"

import "./praise.vue?vue&type=style&index=0&id=601e0ac5&scoped=true&lang=css"

import exportComponent from "D:\\Code\\mt\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601e0ac5"]])

export default __exports__